module.exports = __webpack_public_path__ + "static/step2_mission_pay_card_2-7c43b0cef935800c3d33b17f9b22c7f8.svg";